import React from 'react'
import AddVehicleContainer from '../../../../Components/VehicleContainer/AddVehicleContainer/AddVehicleContainer'
import Layout from '../../Layout'

const AddVehicle = () => {
  return (
    <Layout>
        <AddVehicleContainer/>
    </Layout>
  )
}

export default AddVehicle